import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IAddCustomerStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;    
    lsOrgsTxt: string;
    lsAddTxt: string;
    lsEditTxt: string;
    lsOrgName: string;
    lsExampleTxt: string;
    lsContactFirstNameTxt: string;    
    lsContactLastNameTxt: string;
    lsContactPhoneTxt: string;
    lsContactEmailTxt: string;    
    lsAddressTxt: string;
    lsCityTxt: string;
    lsStateTxt: string;
    lsCountryTxt: string;
    lsZipPostalCodeTxt: string;
    lsOrgEmailTxt: string;
    lsWebsiteTxt: string;
    IsViewInAppBaseline: string;
    IsViewInAppTestTxt: string;
    lsAddOrgTxt: string;
    lsEditOrgTxt: string;
    lsCancelTxt: string;
    lsAddOrgSuccessTxt: string;
    lsOrgExistTxt: string;
    lsAddOrgFailedTxt: string;
    lsUpdateOrgSuccessTxt: string;
    lsUpdateOrgFailedTxt: string;
    lsSaveTxt: string;
    lsNextTxt: string;
    lsNameTxt: string;
    lsValueTxt: string;
    lsContactJobTitle: string;
    lsSelectRegion: string;
    lsCustomerExistsTxt: string;
}

let strings: IAddCustomerStrings;
export default strings = new LocalizedStrings({
    en: {
        lsHomeTxt: 'Home',
        lsOrgsTxt: 'Customers',
        lsAddTxt: 'Add Customer',
        lsNextTxt: 'Next',
        lsEditTxt: 'Edit',
        lsOrgName: 'Customer Name',
        lsExampleTxt: 'e.g.',
        lsContactFirstNameTxt: 'Customer Contact First Name',    
        lsContactLastNameTxt: 'Customer Contact Last Name',    
        lsContactPhoneTxt: 'Customer Contact Phone',
        lsContactEmailTxt: 'Customer Contact Email',   
        lsContactJobTitle: 'Customer Contact Job Title', 
        lsAddressTxt: 'Customer Address',
        lsCityTxt: 'Customer City',
        lsStateTxt: 'Customer State',
        lsCountryTxt: 'Customer Country',
        lsZipPostalCodeTxt: 'Customer Zip/Postal Code',
        lsOrgEmailTxt: 'Customer Email',
        lsWebsiteTxt: 'Customer Website',
        lsEnableBestBaseline: 'Enable Best Baseline',
        lsEnableFailedTestReport: 'Enable Failed Test Report',
        IsTestTags: 'Test Tags',
        IsPrivacyEnabled: 'Is Privacy Enabled',        
        IsViewInAppTestTxt: 'View Test In App',
        IsViewInAppBaseline: 'View Baseline In App',
        lsAddOrgTxt: 'Add Customer',
        lsEditOrgTxt: 'Edit Customer',
        lsCancelTxt: 'Cancel',
        lsAddOrgSuccessTxt: 'Customer Added Successfully',
        lsOrgExistTxt: 'Customer Already Exist',
        lsAddOrgFailedTxt: 'Failed to Add Customer',
        lsUpdateOrgSuccessTxt: 'Customer Updated Successfully',
        lsUpdateOrgFailedTxt: 'Failed to Edit Customer',
        lsSaveTxt: 'Save',
        lsNameTxt: 'Name',
        lsValueTxt: 'Value',
        lsSelectRegion: 'Select State',
        lsCustomerExistsTxt: 'Customer name already exists'
    },
    es: {
        lsHomeTxt: 'Casa',
        lsOrgsTxt: 'Clientes',
        lsAddTxt: 'Añadir',
        lsEditTxt: 'Editar',
        lsOrgName: 'Nombre de la Cliente',
        lsExampleTxt: 'p.ej.',
        lsContactFirstNameTxt: 'Cliente Nombre de pila de contacto',    
        lsContactLastNameTxt: 'Cliente Apellido de contacto',
        lsContactPhoneTxt: 'Cliente Contacto Teléfono',
        lsContactEmailTxt: 'Cliente Contacto Correo electrónico',    
        lsAddressTxt: 'Customer Address',
        lsCityTxt: 'Customer City',
        lsStateTxt: 'Customer State',
        lsCountryTxt: 'Customer Country',
        lsZipPostalCodeTxt: 'Customer Zip/Postal Code',
        lsOrgEmailTxt: 'Customer Email',
        lsWebsiteTxt: 'Sitio web de cliente',
        lsEnableBestBaseline: 'Habilitar la mejor línea de base',
        lsEnableFailedTestReport: 'Habilitar informe de prueba fallido',
        IsTestTags: 'Etiquetas de prueba',
        IsPrivacyEnabled: '¿Está habilitada la privacidad',
        IsViewInAppTestTxt: 'Ver prueba en la aplicación', 
        IsViewInAppBaseline: 'Ver línea de base en la aplicación',
        lsAddOrgTxt: 'Agregar cliente',
        lsEditOrgTxt: 'Editar cliente',
        lsCancelTxt: 'Cancelar',
        lsAddOrgSuccessTxt: 'Cliente agregada con éxito',
        lsOrgExistTxt: 'La cliente ya existe',
        lsAddOrgFailedTxt: 'No se pudo agregar la cliente',
        lsUpdateOrgSuccessTxt: 'Cliente actualizada con éxito',
        lsUpdateOrgFailedTxt: 'Failed to Edit Customer',
        lsSaveTxt: 'Save',
        lsNextTxt: 'Next',
        lsNameTxt: 'Name',
        lsValueTxt: 'Value',
        lsContactJobTitle: 'Customer Contact Job Title', 
        lsSelectRegion: 'Select State',
        lsCustomerExistsTxt: 'Customer name already exists'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/customer/string.customer.add.tsx